// Define TypeScript interfaces for the API response
export interface NewsItem {
  title: string;
  main_image: string;
  header: string;
  subheader: string;
  paragraphs: string[];
  other_images: string[];
  slug: string;
}

export interface NewsApiResponse {
  news: NewsItem[];
}

const apiUrl = 'https://dotmedica.com/nodes/getNewsData';

// Fetch function to retrieve news data from the API
export async function fetchNews(): Promise<NewsItem[]> {
  try {
    const response = await fetch(apiUrl);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data: NewsApiResponse = await response.json();
    return data.news;
  } catch (error) {
    console.error("Error fetching news data:", error);
    throw error;
  }
}
